import React from "react";
import { NO_PURCHASE_NECESSARY_TEXT } from "../../utility/complianceCopy";
import "../../style/compliance.css";

/**
 * The mandatory "No Purchase Necessary" disclaimer banner (DTS compliance).
 *
 * Bold, capitalized, visually inescapable. Rendered at the top of the Terms and
 * Official Rules pages and the registration screen. The wording is centralized
 * in complianceCopy.js so it stays identical everywhere.
 *
 * Props:
 *   variant: "bar" (default, full-width strip) | "inline" (softer, for in-page use)
 */
export default function NoPurchaseBanner({ variant = "bar", className = "" }) {
  return (
    <div
      className={`no-purchase-banner no-purchase-banner--${variant} ${className}`}
      role="note"
      aria-label="No purchase necessary disclaimer"
    >
      <p className="no-purchase-banner__text mb-0">
        {NO_PURCHASE_NECESSARY_TEXT}
      </p>
    </div>
  );
}
